var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-between px-3 py-1 border-b border-gray-400 border-solid"},[_c('div',{staticClass:"text-gray-700"},[_vm._v(_vm._s(_vm.title))]),_c('span',[_vm._v(_vm._s(_vm.value === 'NA' ? '-' : _vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }